// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "webfontloader" + "." + "b3e3a6f5" + ".js";
};